import { z } from 'zod';
export const LINK_TYPES = ['peripheral', 'expansion', 'storage', 'cable', 'power', 'other'];
export const createItemLinkSchema = z.object({
    hostItemId: z.string().uuid(),
    peripheralItemId: z.string().uuid(),
    linkType: z.enum(LINK_TYPES),
    notes: z.string().max(500).optional().default(''),
}).refine((data) => data.hostItemId !== data.peripheralItemId, {
    message: 'Cannot link an item to itself',
    path: ['peripheralItemId'],
});
//# sourceMappingURL=itemLinks.js.map